import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';

import { BtnActions, IconTypeEnum, TableColumnType,TableColumn } from '../../../common/interfaces/global-interfaces';
import { NotificationService } from '../../../services/notification.service';
import { SettingsService } from '../../../services/settings.service';
import { LayoutService } from '../../../shared/components/app-layout/shared-layout/layout.service';
import { AppState } from '../../../store';
import { StoreItemActions } from '../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../store/entities/store-item/store-item.model';
import { AddPaymentComponent } from '../../billing-management/payment-list/add-payment/add-payment.component';
import { GET_ALL_PAYMENT_LIST } from '../../billing-management/payment-list/payment.graphql';
import { PaymentList } from '../../billing-management/payment-list/payment.model';

@Component({
  selector: 'app-corporate-payment',
  templateUrl: './corporate-payment.component.html',
  styleUrl: './corporate-payment.component.scss',
  standalone:false,
})
export class CorporatePaymentComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly settings = inject(SettingsService);
  private readonly notify = inject(NotificationService);
  private readonly store = inject(Store<AppState>);
  readonly layoutService = inject(LayoutService);
  private apollo = inject(Apollo);

  title = "Payments List";
  viewDetails = false;
  addPermission: string[] = ["NO_PERMISSION"];
  upsertAction = StoreItemActions.upsertStoreItem;
  deleteAction = StoreItemActions.deleteStoreItem;
  storeEntity = StoreItemEntity.paymentList;
  query = GET_ALL_PAYMENT_LIST;
  viewDetailsTitle = "View Reconcilation batches";
  additionalVariables = {
    pageNumber: 0,
    itemsPerPage: 10,
  };

  tableColumns: TableColumn[] = [];

  tableActions: BtnActions[] = [
    {
      id: "more",
      title: "Actions",
      permissions: ["NO_PERMISSION"],
      icon: "more_horiz",
      iconType: IconTypeEnum.MATERIAL,
      children: [
        {
          id: "view",
          title: "View Details",
          permissions: ["NO_PERMISSION"],
          icon: "visibility",
          iconType: IconTypeEnum.MATERIAL,
        },
      ],
    },
  ];

  ngOnInit(): void {
 this.tableColumns = [
  { keyword: "", title: "SN", type: TableColumnType.index },

  { keyword: "transactionId", title: "Transaction ID" },
  { keyword: "bill.paymentStatus", title: "Payment Status" },
  { keyword: "payerName", title: "Payer Name" },
 { keyword: "clientName", title: "Client Name" },

  {
    keyword: "paidAmount",
    title: "Paid Amount",
    type: TableColumnType.number,
  },
  {
    keyword: "bill.currencyType",
    title: "Currency Type",
  },
  {
    keyword: "transactionDate",
    title: "Transaction Date",
    type: TableColumnType.date,
  },

  { keyword: "bill.paymentType", title: "Payment Type" },
  { keyword: "paymentReferenceId", title: "Payment Ref ID" },

  { keyword: "actions", title: "Actions", isActionColumn: true },
];

  }

  trackById = (_: number, item: PaymentList) => item.id;

 mapPaymentData = (item: any): PaymentList => {
  return {
    ...item,
    billAmount: item.billAmount ?? item.bill?.totalAmount,
    payerName: item.payerName ?? "N/A",
  };
};


  btnClicked(ev: { id: string; data: PaymentList }): void {
    if (!ev?.data) return;

    switch (ev.id) {
      case "view":
        this.onView(ev.data);
        break;

      default:
        console.warn("Unhandled action:", ev.id);
    }
  }

 onView(payment: PaymentList): void {

  
  if (!payment.uuid) {
    this.notify.errorMessage('Payment UUID not found');

    return;
  }

  // Fixed route - added /view
  this.router.navigate([
    "/corporate/payment",
    payment.uuid,
  ]);
}
  onAdd(reconcilation?: PaymentList): void {
    this.settings.openDialogModal({
      component: AddPaymentComponent,
      data: { reconcilation },
      width: "800px",
    });
  }

  closePanel(): void {
    this.viewDetails = false;
    this.layoutService.closePanel();
  }
}

